import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Label, Panel, Radio } from 'react-bootstrap'
import MaskedInput from 'react-maskedinput';
import { IValidation } from './validation';
import { AboType, Gender } from '@nkr/enums/index';
import { FormEvent } from 'react';
import { IListItem } from '@nkr/models/index';

interface IProps {
    recipientAlias: string,
    recipientEmail: string,
    recipientFirstName: string,
    recipientLastName: string,
    recipientUnosCpra: string,
    recipientAboType: number,
    recipientGender: number,
    recipientBirthdate: string,
    recipientPrimaryInsurance: number,
    recipientSecondaryInsurance: number,
    validation: IValidation,
    dirty: boolean,
    insuranceList: IListItem[],
    onDataChange: (field: string, value: any) => void
}

const RecipientDetails = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { id, value } = e.currentTarget;
        props.onDataChange(id, value);
    };

    return (
        <Panel>
            <Panel.Heading>Recipient Details</Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <FormGroup validationState={props.dirty && (!props.validation.recipientAlias || !props.validation.recipientAliasDuplicate) ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's Alias:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='recipientAlias'
                                value={props.recipientAlias}
                                onChange={handleFieldChange}
                            />
                            {!props.validation.recipientAliasDuplicate && (
                                <HelpBlock><Label bsStyle="danger" bsSize="large">A donor shield direct record already exists with this recipient alias</Label></HelpBlock>
                            )}
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's Email:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='recipientEmail'
                                value={props.recipientEmail}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.recipientFirstName ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's First Name:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl id='recipientFirstName' value={props.recipientFirstName} onChange={handleFieldChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.recipientLastName ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's Last Name:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl id='recipientLastName' value={props.recipientLastName} onChange={handleFieldChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && props.validation.recipientUnosCpra == false ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's UNOS CPRA:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='recipientUnosCpra'
                                value={props.recipientUnosCpra}
                                onChange={handleFieldChange}
                                maxLength={3}
                            />

                            <HelpBlock>This should be a number only; do not include a percent sign.</HelpBlock>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.recipientAboType ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's ABO:</Col>
                        <Col xs={12} lg={6}>
                            <Radio inline id='recipientAboType' name='recipientAboType' value={AboType.O} checked={props.recipientAboType == AboType.O} onChange={handleFieldChange}>O</Radio>
                            <Radio inline id='recipientAboType' name='recipientAboType' value={AboType.A} checked={props.recipientAboType == AboType.A} onChange={handleFieldChange}>A</Radio>
                            <Radio inline id='recipientAboType' name='recipientAboType' value={AboType.B} checked={props.recipientAboType == AboType.B} onChange={handleFieldChange}>B</Radio>
                            <Radio inline id='recipientAboType' name='recipientAboType' value={AboType.Ab} checked={props.recipientAboType == AboType.Ab} onChange={handleFieldChange}>AB</Radio>
                            <Radio inline id='recipientAboType' name='recipientAboType' value={AboType.Unknown} checked={props.recipientAboType == AboType.Unknown} onChange={handleFieldChange}>Unknown</Radio>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.recipientGender ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's Gender:</Col>
                        <Col xs={12} lg={6}>
                            <Radio inline id='recipientGender' name='recipientGender' value={Gender.Male} checked={props.recipientGender == Gender.Male} onChange={handleFieldChange}>M</Radio>
                            <Radio inline id='recipientGender' name='recipientGender' value={Gender.Female} checked={props.recipientGender == Gender.Female} onChange={handleFieldChange}>F</Radio>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.recipientBirthdate ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient's Birthdate:</Col>
                        <Col xs={12} lg={6}>
                            <MaskedInput
                                id='recipientBirthdate'
                                className='form-control'
                                mask='11/11/1111'
                                placeholder='mm/dd/yyyy'
                                style={{ borderColor: props.validation.recipientBirthdate ? '#ccc' : '#a94442' }}
                                value={props.recipientBirthdate}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.recipientPrimaryInsurance ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient Insurance (primary):</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                id='recipientPrimaryInsurance'
                                value={props.recipientPrimaryInsurance}
                                onChange={handleFieldChange}
                            >
                                <option value={0}>- Please Select -</option>
                                {props.insuranceList.map(item =>
                                    <option key={'insurance1-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Recipient Insurance (secondary):</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                id='recipientSecondaryInsurance'
                                value={props.recipientSecondaryInsurance}
                                onChange={handleFieldChange}
                            >
                                <option value={-1}>- Please Select -</option>
                                {props.insuranceList.map(item =>
                                    <option key={'insurance2-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default RecipientDetails;